<script>
import {
  RETURNING_USER_CHECKOUT_APPROACH
  , CONSTANT } from '../../utils/constant'
import sharedService from '../../utils/shared-service'

export default {
  name: 'PayBySavedCard',
  props: {
    card: Object,
    onlyUnbind: {
      type: Boolean,
      value: false
    }
  },
  data () {
    return {
      CONSTANT: CONSTANT,
      checkoutApproach: RETURNING_USER_CHECKOUT_APPROACH,
      selectedCheckoutApproach: null,
      selectedBinding: null,
      isSPKChanges: false
    }
  },

  computed: {
    isThirdPartyFIDOEnabled: {
      get () {
        return this.$store.getters.thirdPartyFIDO
      },
      set (value) {
        this.$store.commit('setThirdPartyFIDO', value)
      }
    },
    selectedBindingDetails: {
      get () {
        return this.$store.getters.selectedBindingDetails
      },
      set (value) {
        if (value === null) {
          this.selectedBinding = value
        }
        this.$store.commit('setSelectedBindingDetails', value)
      }
    },
    showBindingIdsList: function () {
      return (this.card.bindingIds && this.card.bindingIds[localStorage.getItem(CONSTANT.APP_INSTANCE_KEY)])
    },
    bindingIds: function () {
      if (this.showBindingIdsList) {
        const formattedList = {}
        for (const [key, items] of Object.entries(this.card.bindingIds[localStorage.getItem(CONSTANT.APP_INSTANCE_KEY)])) {
          formattedList[key] = items.flatMap(item =>
            Object.entries(item).map(([subKey, subValue]) => ({
              label: subKey,
              value: subValue,
              combinedValue: `${key}:${subKey}:${subValue}`
            }))
          )
        }
        return formattedList
      }
    }
  },

  watch: {
    selectedBindingDetails () {
      if (!this.$store.getters.selectedBindingDetails) {
        this.selectedBinding = null
      }
    }
  },
  created () {
    this.selectedBindingDetails = null
    this.isSPKChanges = sharedService.checkFeatureFlag('START_SPK_CHANGES')
  },
  methods: {
    onApproachChange (event) {
      this.selectedBindingDetails = null
      this.$emit('onCheckoutApproachSelection', event.target.value)
      this.$emit('onBindingIdSelection', this.selectedBindingDetails)
    },

    handleChange (event) {
      const [parentKey, selectedValueKey, value] = event.target.value.split(':')
      const selectedBindingId = {
        srcCorrelationId: sharedService.generateUUID(),
        srcDigitalCardId: this.card.scofMaskedCard.srcDigitalCardId,
        serviceId: this.card.scofMaskedCard.serviceId,
        certifiedMfaMethodId: parentKey,
        [selectedValueKey]: value
      }
      this.selectedCheckoutApproach = null
      this.selectedBindingDetails = selectedBindingId
      this.$emit('onCheckoutApproachSelection', this.selectedCheckoutApproach)
      this.$emit('onBindingIdSelection', selectedBindingId)
    }

  }
}
</script>
<template>
  <div
    id="pay-by-saved-card"
    class="flex ml-3">
    <div
      v-if="!onlyUnbind"
      id="checkout_approach"
      class="form-group"
      data-test="checkout_approach">
      <label>{{ $t("label.checkoutApproach") }}</label>
      <select
        id="authentication-reason-ID"
        v-model="selectedCheckoutApproach"
        class="option-dpa form-control"
        data-test="select-checkout-approach"
        @change="onApproachChange">
        <option
          value="null"
          disabled
          selected>
          {{ $t("label.checkoutApproach") }}
        </option>
        <option
          v-for="(approach) in checkoutApproach"
          :key="approach.value"
          :value="approach.value">
          {{ approach.key }}
        </option>
      </select>
    </div>
    <div
      v-if="showBindingIdsList"
      class="mt-3">
      <label>{{ $t("label.bindingId") }}</label>

      <select
        id="binding-details"
        v-model="selectedBinding"
        class="option-dpa form-control"
        @change="handleChange">
        <option
          value="null"
          disabled
          selected>
          {{ $t("label.bindingId") }}
        </option>
        <optgroup
          v-for="(items, parentKey) in bindingIds"
          :key="'group-' + parentKey"
          :label="$t('label.certifiedMfaMethodId') +' - '+ parentKey"
        >
          <option
            v-for="item in items"
            :key="item.value"
            :value="item.combinedValue">
            {{ item.label }} - {{ item.value }}
          </option>
        </optgroup>
      </select>
    </div>
    <div
      v-if="isSPKChanges && !onlyUnbind"
      id="authPreferenceId"
      class="mt-3">
      <div
        id="auth-preference-id"
        class="ml-2">
        <div
          v-for="(key, value) in CONSTANT.CONFIG.THIRDPARTY_FIDO"
          :key="value"
          class="form-check form-check-inline">
          <input
            :id="'inlineRadio' + key"
            v-model="isThirdPartyFIDOEnabled"
            :data-test="'radio-' + key"
            :value="key"
            name="authPreference"
            class="form-check-input"
            type="radio" >
          <label
            :for="'inlineRadio' + key"
            class="form-check-label">
            {{ value }}
          </label>
        </div>
      </div>
    </div>
  </div>
</template>
